import { faDownload, faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import DocumentViewerModal from 'src/components/document-viewer/DocumentViewerModal';

const RunDocumentItem = ({ document, userList }) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const { name, content, created, user } = document;

  const src = name || content || '';
  const canPreview = /(\.pdf|\.png|\.jpe?g|\.docx)(?:$|\?)/i.test(src);

  const userName = userList?.[user]?.name || 'Unknown user';

  return (
    <div className="run-document-item">
      <div className="run-document-item__details">
        <span className="run-document-item__title">
          {name}
        </span>
        <span className="run-document-item__text">
          Uploaded by {userName} on {dayjs(created).format('DD MMM YYYY, HH:mm')}
        </span>
      </div>
      <div className="btn-group btn-group-sm mt-1 wi-doc-toolbar" role="group" aria-label="Document toolbar">
        {canPreview && (
        <>
          <button
            type="button"
            className="btn btn-outline-secondary d-inline-flex align-items-center wi-doc-btn wi-doc-btn-view"
            title="View"
            aria-label="View"
            onClick={() => setIsViewerOpen(true)}
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
          <DocumentViewerModal
            isOpen={isViewerOpen}
            url={content || null}
            name={name || 'Document'}
            onClose={() => setIsViewerOpen(false)}
          />
        </>
          )}
        <a
          className="btn btn-outline-secondary d-inline-flex align-items-center wi-doc-btn wi-doc-btn-download"
          href={content}
          download={name || 'document'}
          title="Download"
          aria-label="Download"
        >
          <FontAwesomeIcon icon={faDownload} />
        </a>
      </div>
    </div>
  )
}

export default RunDocumentItem;

RunDocumentItem.propTypes = {
  document: PropTypes.object.isRequired,
  userList: PropTypes.object.isRequired,
};
